import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { User, UserProfile } from 'solar-bo';
import { GlobalService } from '@solar/services/global.service';
import { AppConfig } from '@solar/app.config';
import { AlertService, DialogdeleteComponent, DialoginfoComponent, DialogQuestionComponent } from 'basecomponents';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogUploadComponent } from '../uploadDialog/dialog-upload.component';
import { Subscription } from 'rxjs';
import { Notification } from '../notificationsview';
import { UserService } from '@solar/admin/users/user.service';
import { AlertType, MessageError } from 'base-models';


@Component({
  selector: 'app-frms-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  user: User;
  userfullname: string = "";
  location: Location;
  mobile_menu_visible: any = 0;
  backGroundColor = 'darkblue';
  @Output() toggleEvent: EventEmitter<any> = new EventEmitter();

  version: string = AppConfig.app_version;

  logopath = "";
  notificationSub: Subscription;

  constructor(location: Location
    , private router: Router
    , private globService: GlobalService
    , public dialog: MatDialog
    , private adminService: UserService
    , private alertService:AlertService

    ,
  ) {
    this.location = location;
    this.backGroundColor= this.globService.ui_main_options.palette;
    this.globService.uiMainOptionsEvent.subscribe(res=>this.ui_main_optionsEventHandler(res));
        
    this.notificationSub = this.globService.notifyService.notifications$.subscribe((notifications) =>
      this.notifyMessagesHandler(notifications)
    );
  }



  ngOnInit() {

    //this.user=this.globalService.currentUserValue;
    this.user = this.globService.currentUserValue;
    this.userfullname = this.user.name + " " + this.user.surname;
    this.logopath = this.user.company.id;
    /* this.listTitles = ROUTES.filter(listTitle => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;

    this.router.events.subscribe((event) => {


    });
 */
    //this.user=this.getUserLogged();


  }

  ui_main_optionsEventHandler(ui_options){
    this.backGroundColor=ui_options.palette;
  }

  logout() {
    this.globService.logout();
    //this.router.navigate(['/login']);
  }

  cleanCache() {

    let dialogRef = this.openDialogDelete("Clean Cache ", "Do you want to clean cache? We store data in your browser due to a huge amount of data.");
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => {
      dialogRef.close();
      this.globService.cleanCache();
    }
    );
  }

  uploadQueueItemsCount() {
   
    return this.globService.uploadService.uploader.queue.length;
  }

  openDialogDelete(title: string, message: string): MatDialogRef<DialogdeleteComponent> {
    return DialogdeleteComponent.openDialogDelete(this.dialog, title, message, null, "Clean");

  }
  /**
   * signal to show/hide toolbar
   * @param $event 
   */
  toggleSidebar($event) {
    this.toggleEvent.emit();
  }

  showUploadViewEventHandler($event = null) {
    DialogUploadComponent.openModalWithModel(this.dialog, "Upload Queue", null, true);
    this.notificationsDisplay = false;
  }

  notifications: any[] = [];
  notificationsCount: number = 0;
  lastVersionChecked: string = "";
  notifyMessagesHandler(messages: Notification[]) {
    //console.log("notifyMessagesHandler", messages);
    this.notifications = messages;
    if (messages) {
      this.notificationsCount = messages.length;
    }
    if (this.uploadQueueItemsCount() > 0) {
      this.notificationsCount += 1;
    }
    if (messages && messages.length > 0) {
      for (let mes of messages) {
        if (mes.id == "VERSION_NEW") {
          if (this.lastVersionChecked != mes.messageObject.version) {
            this.lastVersionChecked = mes.messageObject.version;
            this.versionCheckShowDialog(mes);
            break;
          }

        }
      }
    }
  }

  private versionCheckShowDialog(message: Notification) {
    let obj = message.messageObject;
    if (obj.version !== AppConfig.app_version) {
      let title = "New version available";
      let dlg_message = "There is a new version available.<br>Version number: <b>" + obj.version + "</b><br> Please reload all windows.";
      let dialogRef = DialogQuestionComponent.openDialog(this.dialog, title, dlg_message, null);

      dialogRef.componentInstance.mainActionEmitter.subscribe(() => {
        location.reload();
      });
    }

  }

  notificationsDisplay: boolean = false;
  shownotiifications() {
    this.notificationsDisplay = !this.notificationsDisplay;
  }

  changeUIColor(color){
    this.globService.ui_main_options.palette=color;
    this.globService.uiMainOptionsEvent.emit(this.globService.ui_main_options);
    this.saveUserPreferences(color);
  }


  //SAVE USER PROFILE
  saveUserPreferences(palette:string) {
    try {
      const cloneModel: User = this.prepareSave();
      
      cloneModel.info["PREFERENCES"] ={palette:palette};
      //update
      this.adminService.updateUser(cloneModel)
        .subscribe(userSaved => this.saveUserPreferencesHandleResult(cloneModel,userSaved), err => this.saveUserPreferencesHandleError(err)
        );
    } catch (error) {
      this.alertService.error("Error saving user. Message: " + error.message);
      console.log(error);
    }

  }

  saveUserPreferencesHandleResult(resultmodel: User,userSaved:User) {
    let msg = new MessageError(AlertType.Success, 'User  profile saved');
    this.alertService.success("User saved");
    Object.assign(this.user.info,userSaved.info);

    this.globService.addAction("USER_CHANGED",this.user);
  }

  saveUserPreferencesHandleError<T>(err: any) {
      this.alertService.error("Error saving user. Message: " + err.message);

  }

  prepareSave(): any {
    const cloneModel: User = new User();
    let user:User=this.user;
    cloneModel.id = user.id;

    cloneModel.id_company = this.globService.currentUserValue.company.id;
    cloneModel.name = user.name;
    cloneModel.surname = user.surname;

 
    cloneModel.profile = new UserProfile();
    cloneModel.profile.access_level =  user.profile.access_level;;

    cloneModel.username = user.username;
    cloneModel.info = user.info;
    cloneModel.info.sites=undefined;
    //let pwd: string = formModel.password;
/*     if (pwd !== this.nopwd) {
      const hashpsw = Md5.hashStr(formModel.password).toString();
      cloneModel.password = hashpsw;
    }
    else {
      //cloneModel.password = this.nopwd;
    } */

    

    return cloneModel;
  }

   //SAVE USER PROFILE
}
